import type { MenubarDesignTokens, MenubarTokenSections } from '@primeuix/themes/types/menubar';

export const root: MenubarTokenSections.Root = {
    background: '{content.background}',
    borderColor: '{content.borderColor}',
    borderRadius: '{content.borderRadius}',
    color: '{content.color}',
    gap: '0.5rem',
    padding: '0.5rem 0.75rem',
    transitionDuration: '{transitionDuration}'
};

export const baseItem: MenubarTokenSections.BaseItem = {
    borderRadius: '{content.borderRadius}',
    padding: '{navigation.item.padding}'
};

export const item: MenubarTokenSections.Item = {
    focusBackground: '{navigation.item.focusBackground}',
    activeBackground: '{navigation.item.activeBackground}',
    color: '{navigation.item.color}',
    focusColor: '{navigation.item.focusColor}',
    activeColor: '{navigation.item.activeColor}',
    padding: '{navigation.item.padding}',
    borderRadius: '{navigation.item.borderRadius}',
    gap: '{navigation.item.gap}',
    icon: {
        color: '{navigation.item.icon.color}',
        focusColor: '{navigation.item.icon.focusColor}',
        activeColor: '{navigation.item.icon.activeColor}'
    }
};

export const submenu: MenubarTokenSections.Submenu = {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}',
    background: '{content.background}',
    borderColor: '{content.borderColor}',
    borderRadius: '{content.borderRadius}',
    shadow: '{overlay.navigation.shadow}',
    mobileIndent: '1rem',
    icon: {
        size: '{navigation.submenu.icon.size}',
        color: '{navigation.submenu.icon.color}',
        focusColor: '{navigation.submenu.icon.focusColor}',
        activeColor: '{navigation.submenu.icon.activeColor}'
    }
};

export const separator: MenubarTokenSections.Separator = {
    borderColor: '{content.borderColor}'
};

export const mobileButton: MenubarTokenSections.MobileButton = {
    borderRadius: '{extend.borderRadius.rounded}',
    size: '1.75rem',
    color: '{text.mutedColor}',
    hoverColor: '{text.hoverMutedColor}',
    hoverBackground: '{content.hoverBackground}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export default {
    root,
    baseItem,
    item,
    submenu,
    separator,
    mobileButton
} satisfies MenubarDesignTokens;
